import { useSeguroFicha } from "./SeguroFicha";
import Promocion from "../../Components/Configuracion/Promocion/Promocion";

/* ============================================================================
   SEGUROS-PLANES FASE 2 · pestaña Promociones.

   El encargo es explícito: filtrarla por el seguro, no rediseñarla. Así que
   esto es la sección de Promociones de siempre, con `seguroId` puesto — y el
   filtro lo aplica el SERVIDOR (P1), no el navegador.
   ========================================================================== */

export default function SeguroPromociones() {
    const { idseguro } = useSeguroFicha();
    return <Promocion seguroId={idseguro} />;
}
